import { ZfFormField, ZfInput } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import { useShadowRootCustomStyles } from '../../../hooks/useShadowRootCustomStyles';
import type { ITranslation } from '../../../interfaces/generic';

interface IMultiLanguageInputProps {
    language: string;
    value?: ITranslation;
    multiline?: boolean;
    rows?: number;
    height?: number;
    onChange: (translation: ITranslation) => void;
}

export const MultiLanguageInput: FunctionComponent<IMultiLanguageInputProps> = ({ language, value, multiline, rows, height, onChange }) => {
    const inputRef = useRef<HTMLZfInputElement>(null);

    useShadowRootCustomStyles(inputRef, `textarea { min-height: calc(${height}px -  2 * var(--zf-input-padding-content-vertical)); }`);

    return (
        <ZfFormField label={language} mandatory={true} style={{ flex: 1 }}>
            <ZfInput
                ref={inputRef}
                placeholder="Amount"
                value={value ? value[language] : ''}
                multiline={multiline}
                rows={!height ? rows : 1}
                onInputChange={(e) => onChange({ ...(value || {}), [language]: e.detail })}
            />
        </ZfFormField>
    );
};
